import {epos2Axios} from "@/interceptors/axios";

class BrandDataService {
    getAll() {
        return epos2Axios.get('/api/brands');
    }

    get(brandId) {
        return epos2Axios.get('/api/brand/'+brandId);
    }

    save(formData) {
       /* const interceptors = () => {
            epos2Axios.interceptors.request.use(config => {
                config.data = formData;
                config.headers.setContentType("multipart/form-data");
                return config;
            });
        };
        interceptors(); //call the interceptors function*/

        return epos2Axios.post(
            '/api/brand',
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
            );
    }

    delete(brandId) {
        return epos2Axios.delete('/api/brand/'+brandId);
    }

    findByBrand(query) {
        return epos2Axios.get('/api/brands?query='+query);
    }
}

export default new BrandDataService();